
import { Component, Vue } from "vue-property-decorator";
import { Settings } from "../../../core/services/configService";
import { CrudService } from "../../../core/services/crudService";
import ProductCard from "../../../components/productCard/productCard.vue";
import { LocalStorage } from "@shared/core/localStorage";

@Component({
  components: {
    ProductCard,
  },
})
export default class VouchersBanner extends Vue {
  vouchers: any[] = [];

  async mounted() {
    let cid = null;
    let sid = LocalStorage.getWithTimeout("cc");
    if (sid != null) {
      cid = JSON.parse(sid).id;
    }
    let url =
      cid == null
        ? `${Settings.HostName}/api/publicvouchers/list-by-customer`
        : `${Settings.HostName}/api/publicvouchers/list-by-customer/${cid}`;
    let data = await new CrudService().httpGet(url);
    if (data == null || !data.ok) {
      console.error("Crash");
      return;
    }
    this.vouchers = data.model;
    this.checkScroll();
    window.addEventListener("resize", this.checkScroll);
  }

  beforeDestroy() {
    window.removeEventListener("resize", this.checkScroll);
  }

  checkScroll() {
    this.$nextTick(() => {
      const container = this.$refs
        .vouchersBannerContainer as HTMLElement | null;
      const list = this.$refs.vouchersBannerList as HTMLElement | null;

      if (container && list) {
        const hasHorizontalScroll = list.scrollWidth > container.clientWidth;
        list.style.justifyContent = hasHorizontalScroll
          ? "flex-start"
          : "center";
      }
    });
  }
}
